import { CalendarDays, Clock, MapPin, Navigation } from "lucide-react";
import { useLang } from "../../i18n";
import { Reveal, Overline } from "./Reveal";
import { IMAGES, DIRECTIONS_URL } from "../../data";

export const Visit = () => {
  const { t } = useLang();

  return (
    <section id="visit" data-testid="visit-section" className="bg-parchment py-24 md:py-36">
      <div className="mx-auto max-w-[1440px] px-6 md:px-14">
        <Reveal>
          <Overline>{t.visit.overline}</Overline>
          <h2 className="mt-5 font-serif text-4xl font-medium leading-[1.05] tracking-tight text-ink md:text-6xl">
            {t.visit.title}
          </h2>
        </Reveal>

        <div className="relative mt-16 grid grid-cols-1 gap-10 lg:grid-cols-12">
          <div className="lg:col-span-7">
            <Reveal delay={0.1}>
              <div className="border border-ink/10 shadow-[0_8px_30px_rgb(0,0,0,0.06)]">
                <img
                  src={IMAGES.nyWinter}
                  alt="Istituto Italiano di Cultura di New York, 686 Park Ave"
                  loading="lazy"
                  className="block w-full"
                />
              </div>
            </Reveal>
          </div>

          <div className="lg:col-span-5">
            <Reveal delay={0.2}>
              <div className="border border-ink/12 bg-cream p-8 md:-ml-16 md:mt-16 md:p-12" data-testid="venue-card">
                <p className="text-[11px] font-semibold uppercase tracking-[0.28em] text-panettone">{t.visit.venue}</p>
                <p className="mt-5 flex items-start gap-3 font-serif text-2xl font-medium leading-snug text-ink" data-testid="venue-address">
                  <MapPin size={22} className="mt-1 shrink-0 text-panettone" />
                  {t.visit.address}
                </p>
                <div className="mt-6 space-y-3 border-t border-ink/10 pt-6 text-[15px] text-ink/70">
                  <p className="flex items-center gap-3" data-testid="venue-dates">
                    <CalendarDays size={16} className="text-panettone" /> {t.visit.dates}
                  </p>
                  <p className="flex items-center gap-3" data-testid="venue-hours">
                    <Clock size={16} className="text-panettone" /> {t.visit.hours}
                  </p>
                </div>
                <a
                  href={DIRECTIONS_URL}
                  target="_blank"
                  rel="noopener noreferrer"
                  data-testid="directions-btn"
                  className="mt-8 inline-flex items-center gap-3 bg-ink px-7 py-3.5 text-[12px] font-semibold uppercase tracking-[0.2em] text-cream transition-colors duration-500 hover:bg-panettone"
                >
                  <Navigation size={14} /> {t.visit.directions}
                </a>
                <div className="mt-8 border-t border-ink/10 pt-6">
                  <p className="text-[11px] font-semibold uppercase tracking-[0.22em] text-ink/55">{t.visit.transportTitle}</p>
                  <p className="mt-2 text-sm leading-relaxed text-ink/60">{t.visit.transport}</p>
                </div>
              </div>
            </Reveal>
          </div>
        </div>

        <Reveal delay={0.1}>
          <div className="mt-14 border border-ink/10 shadow-[0_8px_30px_rgb(0,0,0,0.06)]">
            <iframe
              title="Mappa — Istituto Italiano di Cultura, 686 Park Ave, New York"
              data-testid="venue-map"
              src="https://maps.google.com/maps?q=686%20Park%20Ave%2C%20New%20York%2C%20NY%2010065&t=&z=16&ie=UTF8&iwloc=&output=embed"
              className="h-[380px] w-full md:h-[440px]"
              loading="lazy"
              allowFullScreen
              referrerPolicy="no-referrer-when-downgrade"
            />
          </div>
        </Reveal>
      </div>
    </section>
  );
};
